import React from 'react';
import { Link } from 'react-router-dom';


function Navbar(props) {
    return (
        <nav className="navbar navbar-expand-lg p-1" style={{ background: props.BGColor }} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
            <div className="container-fluid d-lg-flex" data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                <Link className="navbar-brand col-lg-2" to="/" style={{ color: props.color }} data-aos="zoom-in" data-aos-duration="1000">Scammer</Link>
                <button className="navbar-toggler" style={{ color: props.color, border: "#fff" }} type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="img"><i className="fa-solid fa-bars" data-aos="fade-in"></i></span>
                </button>
                <div className="collapse navbar-collapse col-lg-5 justify-content-end" id="navbarTogglerDemo02">
                    <ul className="navbar-nav" data-aos-duration="1000" data-aos="zoom-in" data-aos-delay="100" style={{ fontSize: "20px" }}>
                        <li className="nav-item p-3">
                            <Link className={`nav-a text-decoration-none text-${props.mode === "light" ? "dark " : "light"}`} aria-current="page" to="/">Home</Link>
                        </li>
                        <li className="nav-item p-3">
                            <Link className={`nav-a text-decoration-none text-${props.mode === "light" ? "dark " : "light"}`} aria-current="page" to="/about">About Us</Link>
                        </li>
                        <li className="nav-item p-3">
                            <Link className={`nav-a text-decoration-none text-${props.mode === "light" ? "dark " : "light"}`} aria-current="page" to="/project">Projects</Link>
                        </li>
                        <li className="nav-item p-3">
                            <Link className={`nav-a text-decoration-none text-${props.mode === "light" ? "dark " : "light"}`} aria-current="page" to="/contactme">Contact Me</Link>
                        </li>
                    </ul>
                    <div style={{ margin: "10px" }} data-aos-duration="1000" data-aos="zoom-in">
                        <input type="checkbox" className="checkbox" id="checkbox" onChange={props.changeMode} />
                        <label htmlFor="checkbox" className="checkbox-label" style={{ background: props.BGColor === "#DEF2F1" ? "#17252A" : "#DEF2F1" }}>
                            <span className="ball" style={{ background: props.BGColor }}></span>
                        </label>
                    </div>
                </div>
            </div >
        </nav >
    )
}

export default Navbar
